import { Badge, Tabs } from 'antd';
import InfoTab from './InfoTab';
import ContactTab from './ContactTab';
//import PhotosTab from './PhotosTab';
import { t } from 'i18next';

import "./styleTabs.css"
import { CategoryTab } from './CategoryTab';
import { ServiceTab } from './ServiceTab';
import { RegularScheduleTab } from './RegularScheduleTab';
import { SpecialScheduleTab } from './SpecialScheduleTab';

export const LocationDrawerTabs = ({ location/*, mediaItems, setPostImagesVisible*/ }: any) => {    

    return (
        <div className='tab-container'>
            
            <Tabs defaultActiveKey="1" type="line" >                

                <Tabs.TabPane
                    tab={
                        <Badge color={location.shieldFields?.title === 'ALERT' ? 'Crimson' : 'transparent'} dot size='small'>
                            <span className='title-tabPane'>
                                {t('dictionary.info')}
                            </span>
                        </Badge>
                    }
                    key="1">
                    <InfoTab location={location} locationsIds={location.name.split()}/>
                </Tabs.TabPane>

                <Tabs.TabPane
                    tab={
                        <Badge color={location.shieldFields?.phoneNumbers === 'ALERT' || location.shieldFields?.websiteUri === 'ALERT' ? 'Crimson' : 'transparent'} dot size='small'>
                            <span className='title-tabPane'>
                                {t('dictionary.contact')}
                            </span>
                        </Badge>
                    }
                    key="2">
                    <ContactTab location={location} locationsIds={location.name.split()}/>
                </Tabs.TabPane>

                <Tabs.TabPane
                    tab={                        
                        <span className='title-tabPane'>
                            {t('dictionary.category')}
                        </span>                        
                    }
                    key="3">
                    <CategoryTab location={location} locationsIds={location.name.split()} />
                </Tabs.TabPane>
                
                <Tabs.TabPane
                    tab={
                        <span className='title-tabPane'>
                             {t('dictionary.services')}
                        </span>
                    }
                    key="4">
                    <ServiceTab location={location} locationsIds={location.name.split()} />
                </Tabs.TabPane>

                <Tabs.TabPane
                    tab={
                        <Badge color={location.shieldFields?.regularHours === 'ALERT' ? 'Crimson' : 'transparent'} dot size='small'>
                            <span className='title-tabPane'>
                                {t('dictionary.schedule')}
                            </span>
                        </Badge>
                    }
                    key="5"
                >
                    <RegularScheduleTab location={location} />

                </Tabs.TabPane>

                <Tabs.TabPane
                    tab={
                        <span className='title-tabPane'
                        >
                            Festivos
                        </span>
                    }
                    key="6"
                >
                    <SpecialScheduleTab location={location} />

                </Tabs.TabPane>
            </Tabs>
        </div>
    );
};
